import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const RECENTLY_VISITED_FEATURE_KEY = 'recentlyVisited';

const MAX_RECENTLY_VISITED = 20;

export interface StoredRecentlyVisitedItem {
  id: string;
  type: string;
  visitedAt: string;
}

interface RecentlyVisitedState {
  data: Record<string, StoredRecentlyVisitedItem[]>;
}

const initialState: RecentlyVisitedState = {
  data: {},
};

const normalizeUserId = (userId: string): string => userId.includes('|') ? userId.split('|')[1] : userId;

export const recentlyVisitedSlice = createSlice({
  name: RECENTLY_VISITED_FEATURE_KEY,
  initialState,
  reducers: {
    recordVisit: (state, action: PayloadAction<{ userId: string; item: StoredRecentlyVisitedItem }>) => {
      const { item } = action.payload;
      const key = normalizeUserId(action.payload.userId);
      if (!state.data[key]) {
        state.data[key] = [];
      }
      const existingIndex = state.data[key].findIndex((visited) => String(visited.id) === String(item.id));
      if (existingIndex !== -1) {
        state.data[key].splice(existingIndex, 1);
      }
      state.data[key].unshift(item);
      if (state.data[key].length > MAX_RECENTLY_VISITED) {
        state.data[key] = state.data[key].slice(0, MAX_RECENTLY_VISITED);
      }
    },
    removeVisit: (state, action: PayloadAction<{ userId: string; itemId: string }>) => {
      const { itemId } = action.payload;
      const key = normalizeUserId(action.payload.userId);
      if (state.data[key]) {
        state.data[key] = state.data[key].filter((item) => String(item.id) !== String(itemId));
      }
    },
  },
});

export const { recordVisit, removeVisit } = recentlyVisitedSlice.actions;

export const recentlyVisitedReducer = recentlyVisitedSlice.reducer;

const getRecentlyVisitedState = (rootState: any): RecentlyVisitedState => rootState[RECENTLY_VISITED_FEATURE_KEY];

export const recentlyVisitedSelectors = {
  forUser: (state: any, userId: string): StoredRecentlyVisitedItem[] => {
    const key = normalizeUserId(userId);
    return getRecentlyVisitedState(state)?.data?.[key] ?? [];
  },
};
